var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{attrs:{"value":_vm.isLoading,"opacity":".5","z-index":"6"}},[_c('v-img',{staticClass:"animate-flicker",attrs:{"alt":"Aquality Logo","contain":"","src":require("@/assets/loading.png"),"width":"75"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }